import type { PeriodResultKey } from './historySelectors';
import type { OrderFilter, UserMetricKey } from './types';

export const RESULT_COLORS: Record<PeriodResultKey, string> = {
  completed_on_time: '#52C41A',
  completed_late: '#FAAD14',
  supervisor_closed: '#13A8A8',
  partial: '#3F8DD8',
  no_activity: '#BFBFBF',
  canceled: '#595959',
};

export const INCIDENT_CATEGORIES = [
  { key: 'normal', color: '#52C41A' },
  { key: 'delay', color: '#8B5CF6' },
  { key: 'late', color: '#FAAD14' },
  { key: 'unfulfilled', color: '#9CA3AF' },
] as const;

export type IncidentCategoryKey = (typeof INCIDENT_CATEGORIES)[number]['key'];

export const RANKING_PAGE_SIZE = 5;
export const MOST_EXECUTED_COLOR = '#3F8DD8';

/**
 * Order KPI cards, in display order. `filter` enables the drill-down. `supervisorClosed` only
 * shows when the period has closures (ADR 0002).
 */
export const ORDER_KPIS: Array<{
  key:
    | 'orders'
    | 'completed'
    | 'supervisorClosed'
    | 'completion'
    | 'partial'
    | 'canceled'
    | 'late'
    | 'delay'
    | 'duration';
  filter?: OrderFilter;
}> = [
  { key: 'orders', filter: 'all' },
  { key: 'completed', filter: 'completed' },
  { key: 'supervisorClosed', filter: 'supervisorClosed' },
  { key: 'partial' },
  { key: 'canceled' },
  { key: 'completion' },
  { key: 'late', filter: 'late' },
  { key: 'delay', filter: 'delay' },
  { key: 'duration' },
];

/** User KPI cards, in display order. `filter` enables the drill-down. */
export const USER_KPIS: Array<{ key: UserMetricKey | 'average'; filter?: UserMetricKey }> = [
  { key: 'assigned', filter: 'assigned' },
  { key: 'active', filter: 'active' },
  { key: 'complete', filter: 'complete' },
  { key: 'partial', filter: 'partial' },
  { key: 'inactive', filter: 'inactive' },
  { key: 'average' },
];
